import * as api from '../graphql';
import { graphql } from 'react-apollo';
import { compose } from 'recompose';

export const gqGetPlaces = graphql(api.GET_PLACES);

export default compose(
  graphql(api.DELETE_PRICE_TEMPLATE, { name: 'removeTemplateFromMatch' })
);
